import { useStudentCoursesPanel } from "../api/getStudentCoursesPanel";

import SideBarSection from "./SideBarSection";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
export default function StudentCoursesPanel({ studentId }) {
  const { data } = useStudentCoursesPanel({ studentId });

  return (
    <SideBarSection title={"Cursos concluídos"}>
      <List className="user_info_section_courses">
        {data?.map((course) => {
          return (
            <ListItem>
              <ListItemAvatar>
                <Avatar src={course.fotoCurso}></Avatar>
              </ListItemAvatar>
              <ListItemText
                secondary={new Date(course?.dataConclusao).toDateString()}
              >
                {course.nomeCurso}
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
    </SideBarSection>
  );
}
